import { type FunctionComponent } from 'react';
import { Box, Spinner, Text } from '@chakra-ui/react';
import { ReactComponent as CloseIcon } from '../../../assets/svg/Close.svg';
import { type TargetVessel } from '../../../types';
import { ReactComponent as VesselIcon } from '../../../assets/svg/Vessel.svg';
import { SearchContext } from '../types';

interface Props {
  targetVessel: TargetVessel;
  context: SearchContext;
  onVesselClick: () => void;
  onVesselReset: (event: React.MouseEvent<SVGElement, MouseEvent>) => void;
}

export const VesselBreadcrumb: FunctionComponent<Props> = ({ targetVessel, context, onVesselClick, onVesselReset }) => {
  const isVesselSearchContext = context === SearchContext.Vessel;

  return (
    isVesselSearchContext && (
      <Box className="breadcrumb" onClick={onVesselClick}>
        {targetVessel.name ? (
          <>
            <div className="breadcrumb-icon">
              <VesselIcon />
            </div>
            <Text className="breadcrumb-text vessel-name">{targetVessel.name}</Text>
          </>
        ) : (
          <Spinner w="20px" h="20px" />
        )}
        <div className="breadcrumb-icon">
          <CloseIcon onClick={onVesselReset} />
        </div>
      </Box>
    )
  );
};
